enum PageId {
  MAIN_ENTRY = "MAIN_ENTRY",
  NO_PKGS = "NO_PKGS",
  NOT_FOUND = "NOT_FOUND",
  LOADING = "LOADING",
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  AUTH_CALLBACK = "AUTH_CALLBACK",
  ADMINISTRATION = "ADMINISTRATION",
  MEQ_CAMERA = "MEQ_CAMERA",
  GMP_LAMB_DATA_ANALYSIS = "GMP_LAMB_DATA_ANALYSIS",
  GMP_LAMB_BOOKINGS = "GMP_LAMB_BOOKINGS",
  MEQ_LIVE_GENETICS = "MEQ_LIVE_GENETICS",
  GMP_UPLOAD = "GMP_UPLOAD",
  DATA_ANALYSIS_OVERVIEW = "DATA_ANALYSIS_OVERVIEW",
  MEQ_PROBE = "MEQ_PROBE",
  MANAGEMENT = "MANAGEMENT",
  MEQ_LIVE = "MEQ_LIVE",
  MEQ_LIVE_ADMIN = "MEQ_LIVE_ADMIN",
  USDA_AUDIT = "USDA_AUDIT",
  USDA_AUDIT_FEEDBACK = "USDA_AUDIT_FEEDBACK",
  RECORD_LABELLING = "RECORD_LABELLING",
  MY_ASSIGNMENTS = "MY_ASSIGNMENTS",
  USDA_CALIBRATION = "USDA_CALIBRATION",
}

export default PageId;
